import { render, staticRenderFns } from "./TitleSubtitle.vue?vue&type=template&id=0a721aea&scoped=true"
import script from "./TitleSubtitle.vue?vue&type=script&lang=js"
export * from "./TitleSubtitle.vue?vue&type=script&lang=js"
import style0 from "./TitleSubtitle.vue?vue&type=style&index=0&id=0a721aea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a721aea",
  null
  
)

export default component.exports